import { Box, Stack, Typography, useTheme } from "@mui/material";
import MarkdownPreview from "@uiw/react-markdown-preview";
import { useEffect, useState } from "react";
import { NavbarIcon } from "../../atoms/navbar/Icon";
import { SmallModal } from "../../components/SmallModal";
import { useInstructions } from "../../hooks/useInstructions";
import { InstructionsType } from "../../models/types";

type ShowInstructionsModalProps = {
  open: boolean;
  onClose: () => void;
  type: InstructionsType;
};

export const ShowInstructionsModal = (props: ShowInstructionsModalProps) => {
  const { open, onClose, type } = props;
  const theme = useTheme();

  const { data: instruction, isLoading } = useInstructions({ "type[]": [type] });
  const [instructions, setInstructions] = useState("");

  useEffect(() => {
    if (instruction && instruction?.results?.length > 0) {
      setInstructions(instruction?.results[0]?.instructions);
    } else {
      setInstructions("");
    }
  }, [instruction]);

  return (
    <SmallModal
      open={open}
      onClose={onClose}
      title={`Create ${type}`}
      position="right"
      size="xl"
      isLoading={isLoading}
      customTitle={
        <Box display="flex" flexDirection="row" gap="10px" alignItems="center">
          <Box
            onClick={() => onClose()}
            sx={{ cursor: "pointer" }}
            display="flex"
            alignItems="center"
          >
            <NavbarIcon
              variant="left-arrow"
              sx={{ width: "22px", minWidth: "22px", height: "22px", minHeight: "22px" }}
            />
          </Box>
          <Typography variant="h2">{`Create ${type}`}</Typography>
        </Box>
      }
      showCloseButton={false}
      hideContentPadding
      showTitleContentDivider
    >
      <Stack gap="10px" padding="15px">
        <Box
          data-color-mode={theme.palette.mode}
          sx={{
            fontSize: "0.775rem",
            lineHeight: 1.5,
            color: theme.palette.custom.primaryTypography,
            "& a": { color: theme.palette.custom.blueTypography },
            "& code": {
              backgroundColor: theme.palette.custom.secondaryBackground,
              padding: "2px 4px",
              borderRadius: "3px",
              fontFamily: "monospace",
            },
            "& pre": {
              backgroundColor: theme.palette.custom.secondaryBackground,
              padding: "8px",
              borderRadius: "3px",
              overflow: "auto",
            },
            "& h1, & h2, & h3, & h4, & h5, & h6": {
              marginTop: "1em",
              marginBottom: "0.5em",
              borderBottom: "none !important",
              border: "none !important",
              "& a.anchor": {
                display: "none !important",
              },
            },
            "& p": {
              margin: "8px 0",
            },
            "& ul, & ol": {
              paddingLeft: "20px",
            },
          }}
        >
          <MarkdownPreview
            disableCopy
            source={instructions}
            style={{ backgroundColor: "transparent" }}
          />
        </Box>
      </Stack>
    </SmallModal>
  );
};
